import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { lang } from "../../config/lang";
import { Businesses, BsLink } from "../../config/Helper";
import { Link } from "react-router-dom";
import { replace } from 'react-router-redux';
import store from '../../store/configureStore';
import { getDateString, markUpString } from '../../config/utils';

/****************************************
    Component for special page
    @author  UYM
    @date    2020.05.15
    @version 0.1    
 ******************************************/
const SearchBlock = ({ key, pKey, business, id, title, date, images, keyword, type }) => {
    //     const storeValue = store.getState();
    //     keyword = storeValue.topBanner.searchKey
    const mark = (str, keyword) => {
        const patt = new RegExp(keyword, 'g');
        if (keyword && keyword !== '') {
            return pKey + '. ' + str.replace(patt, `<mark>${keyword}</mark>`)
        }
        return str;
    }
    return (
        <>
            {/* <hr className="solid tall" /> */}
            <div className="project" style={{ marginBottom: "0px" }}>
                <div className="text search-block-text">
                    <Link to={`/${BsLink[business]}/${id}`}>
                        <h3
                            id={`media_${business}_${id}_${images}`}
                            className='ellipsis'
                            caption={pKey + '.' + title}
                            dangerouslySetInnerHTML={{
                                __html: title ?
                                pKey + '. ' + markUpString(title, keyword) : "<font style='visibility: hidden;'>no title</font> "
                            }}>
                        </h3>
                        <div>
                        {
                            type == "text" && <span className="fa fa-file-text"></span> 
                        }
                        {
                            type == "image" && <span className="fa fa-image"></span> 
                        }
                        {
                            type == "video" && <span className="fa fa-video-camera"></span> 
                        }
                        </div>
                    </Link>
                    <h3 className="price">{lang(Businesses[business]) + ' - ' + getDateString(date)}</h3>
                </div>
            </div>
        </>
    )
}
export default withRouter(SearchBlock);
